var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 1.16699H1.33334V18.667H10.0833L13 21.5837L15.9167 18.667H24.6667V1.16699Z",
    stroke: "#1076BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.5003C14.6108 10.5003 15.9167 9.19449 15.9167 7.58366C15.9167 5.97283 14.6108 4.66699 13 4.66699C11.3892 4.66699 10.0833 5.97283 10.0833 7.58366C10.0833 9.19449 11.3892 10.5003 13 10.5003Z",
    stroke: "#1076BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 15.1667C18.25 12.5895 15.8992 10.5 13 10.5C10.1008 10.5 7.75 12.5895 7.75 15.1667",
    stroke: "#1076BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.59ce95c8b8890a73943dea7704768202.svg";
export { ForwardRef as ReactComponent };